type Props = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  isLoading?: boolean;
};

/** Convenience button with loading logic (animation plus disables button while loading). */
export const Button = ({
  isLoading,
  children,
  disabled,
  ...buttonProps
}: Props) => {
  return (
    <button {...buttonProps} disabled={isLoading || disabled}>
      {!isLoading && <span className="w-[12px] opacity-0"></span>}
      {children}
      {isLoading && <span className="loading loading-spinner"></span>}
      {!isLoading && <span className="w-[12px] opacity-0"></span>}
    </button>
  );
};
